/**
 * Server clock, learned from the API's `Date` response header, so countdowns follow the server
 * rather than a payer's wrong device clock. Cross-origin, the header is readable only when the
 * API lists it in `Access-Control-Expose-Headers`; until then the local clock is used.
 */
let offsetMs = 0;

/** Small drift (and the header's one-second resolution) is not worth correcting. */
const MIN_CORRECTION_MS = 2000;

export function syncServerClock(dateHeader: string | null): void {
  if (!dateHeader) return;
  const server = Date.parse(dateHeader);
  if (Number.isNaN(server)) return;
  const offset = server - Date.now();
  offsetMs = Math.abs(offset) < MIN_CORRECTION_MS ? 0 : offset;
}

/** Current time on the server's clock, as far as it is known. */
export function serverNow(): number {
  return Date.now() + offsetMs;
}
